<template>
    <c-dialog ref="dialog" width="800" height="550">
        <c-form ref="importForm" unit-width="100%">
            <c-form-column>
                <c-form-item>
                    <c-steps :steps="steps" :active="active" gap="200"></c-steps>
                </c-form-item>

                <div v-if="active == 1">
                    <div class="import-steps">
                        <h5 v-if="workType == 301">1. 下载【机老大】导入模板</h5>
                        <h5 v-else>1. 下载导入模板</h5>
                        <p >·请按照模板中的列头批注说明填写完善表格中的内容。<c-link @click="downloadTemplate()">下载模板点击这里</c-link></p>
                        <p>·下载模板后，请按<c-link @click="showNoticeMsg()">导入说明</c-link>照填写完善表格中的内容。</p>
                        <p>·当上传的表格有多个Sheet时，只导入第一个Sheet的数据。</p>
                    </div>
                </div>

                <div v-if="workType == 301" v-show="active == 1" class="import-channel">
                    <c-tab-list v-if="channelTabs.length" :tabs="channelTabs" @change="data => offline_purchase_channel = data.value"></c-tab-list>
                    <div class="import-steps">
                        <c-upload-file type="excel" size="5120" folder="temporary" bigger style="margin-top: 10px;" @upload="uploadHandle"></c-upload-file>
                    </div>
                </div>

                <div v-if="active == 1 && workType != 301">
                    <div class="import-steps">
                        <h5>2. 上传完善好的表格</h5>
                        <p>·仅支持上传Excel文件(Excel2007及以上版本)，导入文件最大不超过5MB，单次导入数据不超过999行。</p>
                        <c-upload-file type="excel" size="5120" folder="temporary" bigger style="margin-top: 10px;" @upload="uploadHandle"></c-upload-file>
                    </div>
                </div>
                <div v-if="active == 2">
                    <div class="import-steps">
                        <p>1、 带<b style="margin: 0 5px; color: #f00;">*</b>的数据必须填写（选择对应的Excel表头；或者填写默认数据值）。</p>
                        <p>2、 导入数据会优先从Excel数据列中取值，如果对应的单元格数据为空，将使用【默认数据】中填写的值进行填充。</p>
                        <p>3、 导入的数据仅做解析，自动填写至输入框中，不会自动入库。</p>
                    </div>
                </div>

                <div v-if="active == 2">
                    <c-table ref="table" :data="matchColumnList" height="320" border :paging="false">
                        <c-table-column :label="'系统字段 (共 '+sysColumnTotal+' 列)'" width="180" fixed="left">
                            <template #default="{data}">
                                <div class="flex-left">
                                    {{data.system_column_name}}
                                    <b v-if="data.required==1" style="margin-left: 5px; font-size: 14px; color: #f00;">*</b>
                                </div>
                            </template>
                        </c-table-column>
                        <c-table-column :label="'Excel表头 (共 '+excelColumnTotal+' 列)'" width="250">
                            <template #default="{data}">
                                <c-select name="excel_column_name" :options="excelColumnOptions" v-model="data.excel_column_name"></c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="默认数据" width="160">
                            <template #default="{data}">
                                <c-input v-if="data.field_type == 2"
                                         type="number"
                                         step="1"
                                         step-controls="side"
                                         name="column_default_value"
                                         v-model="data.column_default_value"
                                         :range="[0,99999999]"
                                         decimal="6"
                                         :placeholder="'请输入'||data.system_column_name"
                                ></c-input>

                                <c-input v-else-if="data.is_custom == 1 && data.config_json.type == 'number'"
                                         type="number"
                                         step="1"
                                         step-controls="side"
                                         name="column_default_value"
                                         v-model="data.column_default_value"
                                         :range="[0,99999999]"
                                         :decimal="data.config_json.attr.includes('decimal') ? data.config_json.decimal : 0"
                                         :placeholder="'请输入'||data.system_column_name"
                                ></c-input>

                                <c-datetime v-else-if="data.is_custom == 1 && data.config_json.type == 'time'"
                                            name="column_default_value"
                                            v-model="data.column_default_value"
                                            :type="data.config_json.format.split('|')[1]"
                                            :format="data.config_json.format.split('|')[0]"
                                            :time-accuracy="data.config_json.format.split('|')[2]"
                                            :placeholder="'请选择'||data.system_column_name"
                                ></c-datetime>

                                <template v-else-if="data.is_custom == 1 && data.config_json.type == 'option'">
                                    <c-select
                                            search
                                            name="column_default_value"
                                            v-model="data.column_default_value"
                                            :options="data.config_json.options"
                                            :multiple="data.config_json.attr.includes('multiple')"
                                            :placeholder="'请选择'||data.system_column_name"
                                    ></c-select>
                                </template>

                                <template v-else-if="data.is_custom == 0 && data.field_type == 4">
                                    <c-select
                                            search
                                            name="column_default_value"
                                            v-model="data.column_default_value"
                                            :options="data.options"
                                            :placeholder="'请选择'||data.system_column_name"
                                    ></c-select>
                                </template>

                                <c-input v-else
                                         type="text"
                                         name="column_default_value"
                                         v-model="data.column_default_value"
                                         :placeholder="'请输入'||data.system_column_name"
                                ></c-input>
                            </template>
                        </c-table-column>
                    </c-table>
                </div>

                <div v-if="active == 3">
                    <div class="import-fruit flex-column flex-center">
                        <h1>导入结果</h1>
                        <p>批量导入{{this.importResult.total_count}}条数据；成功：<b style="color: green">{{this.importResult.success_count}}条</b>；失败：<b style="color: red">{{this.importResult.fail_count}}条</b>
                            <c-link v-if="this.importResult.fail_count > 0 && this.importResult.error_file_url" style="margin-left: 20px;" @click="downloadErrorFile()">下载错误报告</c-link>
                        </p>
                    </div>
                </div>
            </c-form-column>
        </c-form>

        <template #button>
            <c-button v-if="active == 2" size="dialog" @click="previousStep()">上一步</c-button>
            <c-button v-if="active == 2 && excel_file && !errorFlag" color="main" size="dialog" @click="submit()">确定导入</c-button>
            <c-button v-if="active == 3" size="dialog" @click="previousStep()">继续导入</c-button>
            <c-button v-if="active == 3" color="main" size="dialog" @click="finish()">导入完成</c-button>
        </template>

        <!--提示信息-->
        <c-dialog ref="noticeDialog" width="700" button-name="我知道了" :cancel-button="false">
            <div v-html="noticeMsg" class="import-explain"></div>
        </c-dialog>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
import dictList from "@/store/dict";

export default {
    name: 'excelImportAnalysis',
    props: {
        workType: [String, Number]
    },
    watch: {
    },
    data() {
        return {
            steps:[
                {'name': '上传文件'},
                {'name': '配置表单'},
                {'name': '导入数据'}
            ],
            active:1,
            import_type:1,
            excel_file:'',
            matchColumnList:[],
            sysColumnTotal:0,           //系统业务总列数
            excelColumnTotal:0,         //导入Excel总列表
            excelColumnOptions:[],       //导入Excel表头信息（去重）
            importResult:null,
            errorFlag:false,
            view_id:0,
            purchase_order_id:0,
            channelList:[],               //线下采购渠道（平台）配置列表
            offline_purchase_channel:''//线下采购渠道（平台）编码
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo','stockinClassifyName','stockoutClassifyName','inventoryClassifyName']),

        //线下采购渠道（平台）页签选项
        channelTabs() {
            return this.channelList.map(item => {
                return {
                    name: item.channel_name,
                    value: item.channel_code
                }
            });
        },

        noticeMsg() {

            var resultMsg = {
                301: [
                    '<p>1、背贴码，<span style="color:red">【必填】</span>，必须是系统中已存在的背贴码，且尚未关联其他采购单：</p>',
                    '<p>2、IMEI码，【选填】必须未关联其他背贴码，最多输入 50 个字符；</p>',
                    '<p>3、分类，<span style="color:red">【必填】</span>，请输入已存在的分类名称；</p>',
                    '<p>4、品牌，<span style="color:red">【必填】</span>，请输入已存在的品牌名称，且该品牌必须归属已选的分类；</p>',
                    '<p>5、机型，<span style="color:red">【必填】</span>，请输入已存在的机型名称，且该机型必须归属已选的品牌；</p>',
                    '<p>6、内存，【选填】，请输入已存在的内存名称，且该内存必须关联所选机型；</p>',
                    '<p>7、颜色，【选填】，请输入已存在的颜色名称，且该颜色必须关联所选机型；</p>',
                    '<p>8、等级，【选填】，请输入已存在的等级名称；</p>',
                    '<p>9、外部订单号：【选填】，最多输入50 个字符；</p>',
                    '<p>10、采购价：<span style="color:red">【必填】</span>，请输入大于0小于999999的数字，最多输入2位小数；</p>',
                    '<p>11、同行价：<span style="color:red">【必填】</span>，请输入大于0小于999999的数字，最多输入2位小数；</p>',
                    '<p>12、零售价：【选填】，请输入大于0小于999999的数字，最多输入2位小数；</p>',
                    '<p>13、备注：【选填】，最大输入500个字符；</p>'
                ].join(''),
            }[this.workType];
            return resultMsg;
        },

        dialogTitle() {
            return {
                301: '【线下采购单商品】'
            }[this.workType]
        }
    },

    methods: {
        /************打开新增、编辑弹窗，数据初始化**************/
        open(data) {
            this.active = 1;//恢复初始值
            this.excel_file = '';
            this.errorFlag = false;
            if (data && data.title){
                this.$refs.dialog.open({
                    title: data.title
                });
            }else {
                this.$refs.dialog.open({
                    title: '导入'+this.dialogTitle+'数据'
                });
            }
            if (data){
                this.view_id = data.view_id||0;                             //默认视图ID
                this.purchase_order_id = data.purchase_order_id||0;         //采购单ID
            }else {
                this.view_id = 0;           //默认视图ID
            }
            //线下采购：加载渠道（平台）配置列表
            if (this.workType == 301){
                this.queryChannelConfigList();
            }
        },

        /*****************查询导入渠道（平台）配置列表**********************/
        queryChannelConfigList() {
            this.request({
                url: '/import/channel/config/list',
                data: {
                    work_type: this.workType
                },
                success: data => {
                    this.channelList = data || [];
                }
            });
        },

        /*****************下载导出模板**********************/
        downloadTemplate(){
            this.request({
                url: '/import/url',
                data: {
                    work_type: this.workType,
                    view_id: this.view_id
                },
                success: data => {
                    this.download({
                        fileName: data.filename,
                        url: data.url,
                        loading: {
                            message: '数据文件生成中...'
                        }
                    });
                }
            });
        },

        /*****************展示导入说明数据**********************/
        showNoticeMsg() {
            this.$refs.noticeDialog.open({
                title: '导入说明'
            });
        },

        /*****************上传文件**********************/
        uploadHandle(data) {
            this.excel_file = data[0].path;
            //上传完成后自动解析表头，并跳转配置表单页面
            this.analysisUploadFile();
        },

        /*****************解析上传成功的Excel文件**********************/
        analysisUploadFile() {
            this.request({
                url: '/import/analysis/excel/head',
                data: {
                    offline_purchase_channel: this.offline_purchase_channel,
                    work_type: this.workType,
                    view_id: this.view_id,
                    url: this.excel_file
                },
                loading: {
                    message: '文件上传解析中...'
                },
                success: data => {
                    this.errorFlag = false;
                    this.matchColumnList = data.matchColumnList || [];
                    this.sysColumnTotal = data.sysColumnTotal || 0;
                    this.excelColumnTotal = data.excelColumnTotal || 0;
                    this.excelColumnOptions = data.excelColumnOptions || [];
                    this.matchColumnList.forEach(field => {
                        field.column_default_value = '';
                        this.handleFieldOptions(field);
                    });
                    setTimeout(() => {
                        this.active = 2;//上传文件完成，跳转配置表单页面
                    }, 500);
                },
                fail: () => {
                    this.errorFlag = true;
                }
            });
        },

        /*****************加载导入字段（选择类型）的下拉选项数据**********************/
        handleFieldOptions(field) {
            //仅系统选择类型字段需按字典加载选项；配置缺失时跳过，避免阻断导入流程
            if (field.is_custom != 0 || field.field_type != 4 || !field.config_json || !field.config_json.dict_config) {
                return;
            }
            var dictConfig = field.config_json.dict_config;
            if (dictConfig.dictType == 'PAGEDIC') {
                var dictData = dictList[dictConfig.dictName] || [];
                this.$set(field, 'options', dictData.map(item => {
                    return {
                        value: item.name,
                        name: item.name
                    };
                }));
            } else if (dictConfig.dictType == 'DBDIC') {
                this.request({
                    url: '/system/options',
                    data: {
                        options_code: dictConfig.dictName
                    },
                    success: data => {
                        var optionsList = (data || []).map(item => {
                            var name = item.name;
                            //客户
                            if ('CUSTOMER' == dictConfig.dictName) {
                                name = item.data.customer_name;
                                //不良品项
                            } else if ('DICDEFECTS' == dictConfig.dictName) {
                                name = item.data.defects_name;
                                //工序
                            } else if ('DICPROCESS' == dictConfig.dictName) {
                                name = item.data.process_name;
                                //工艺路线
                            } else if ('PROCESSROUTE' == dictConfig.dictName) {
                                name = item.data.route_name;
                                //供应商
                            } else if ('SUPPLIER' == dictConfig.dictName) {
                                name = item.data.supplier_name;
                                //仓库
                            } else if ('WAREHOUSE' == dictConfig.dictName) {
                                name = item.data.warehouse_name;
                            }
                            return {
                                value: name,
                                name: name
                            };
                        });
                        this.$set(field, 'options', optionsList);
                    }
                });
            }
        },

        //回退至上一步
        previousStep() {
            this.active = 1;
        },

        //完成
        finish() {
            this.$refs.dialog.close();
        },
        /************下载错误文件************/
        //
        submit() {
            //判断【必填】项是否已填写
            var submitFlag = true;
            let data = this.$refs.table.getData();
            data.forEach(item => {
                if (item.required == 1
                        && (!item.excel_column_name || item.excel_column_name == '')
                        && (!item.column_default_value || item.column_default_value == '')
                ) {
                    submitFlag = false;
                    this.$message({
                        message: '请完善所有带星号的【必填】数据列',  // 提示内容,
                        type: 'warn'
                    });
                    return;
                }
            });
            if (submitFlag) {
                //返回解析完成数据
                this.request({
                    url: '/import/excel/data/list',
                    data: {
                        work_type: this.workType,
                        view_id: this.view_id,
                        url: this.excel_file,
                        match_column_list: data,
                        purchase_order_id:this.purchase_order_id
                    },
                    loading: {
                        message: '导入数据处理中...'
                    },
                    success: data => {
                        this.errorFlag = false;
                        this.importResult = data;
                        setTimeout(() => {
                            this.active = 3;//恢复初始值
                            //执行回调方法
                            this.$emit('resolve',this.importResult.import_data_list||[]);
                        }, 500);
                    },
                    fail: () => {
                        this.errorFlag = true;
                    }
                });
            }
        },

        /************下载错误文件************/
        downloadErrorFile() {
            this.download({
                fileName: this.importResult.error_file_name,
                url: this.importResult.error_file_url,
                loading: {
                    message: '数据文件生成中...'
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.import-steps {
    padding: 10px 20px;
    background-color: #F8F8F8;

    h5 {
        line-height: 36px;
        font-size: 15px;
    }

    p {
        padding: 4px 0;
        line-height: 20px;
        color: #666;
    }
}

.import-channel {
    .c-tab-list {
        margin-bottom: 10px;
    }
}

.import-explain {
    padding: 20px;

    >>> p {
        padding: 4px 0;
        line-height: 20px;
    }
}

.import-fruit {
    height: 200px;
    background-color: #F8F8F8;

    h1 {
        margin-bottom: 30px;
        font-size: 26px;
    }
}
</style>